// extracted by mini-css-extract-plugin
export default {"paper1":"timepicker_paper1__bFnM7","paper2":"timepicker_paper2__5SdDb"};